/* 健康轨迹-模块API */

import { GET, POST, download, uploading, POSTFormData } from '@/request/http'

//位置管理page
export const pagePosition = p => POST('/healthy/position/pageposition', p)
//位置管理add
export const savePosition = p => POST('/healthy/position/saveposition', p)
//位置管理update
export const updatePosition = p => POST('/healthy/position/updateposition', p)
//位置管理delete
export const deletePosition = p => POST('/healthy/position/deleteposition', p)
//位置管理getbyid
export const getPositionById = p => POST('/healthy/position/getpositionbyid', p)

//签到详情page
export const pageSignInfo = p => POST('/healthy/signinfo/pagesigninfo', p)
//导出excel
export const exportSignUserExcel = p => download('/healthy/signinfo/exportsignuserexcel', p)



// WEBPACK FOOTER //
// ./src/api/modules/healthy.js